import { LabelChipV2, LabelChipV2Size } from '@cast/design-system';
import { KarpenterLogo } from '@cast/features-cluster-ui';

type Props = {
  size?: LabelChipV2Size;
};

export const KarpenterLabelChip = ({ size = 'l' }: Props) => {
  return (
    <LabelChipV2
      size={size}
      color="indigo"
      slots={{
        startIcon: <KarpenterLogo size={16} />,
      }}
      label="Karpenter"
    />
  );
};
